import Icon from "../../../components/iconMaster";
import { Link, useLocation } from "react-router-dom";
import CommonModal from "../../../components/modal/CommonModal";
import { lazy, startTransition, useEffect, useRef, useState } from "react";
import InputField from "../../../components/input";
import { useAddDispatch, useAppSelector } from "../../../store";
import { logout } from "../../../auth/userSlice";
import Icons from "../../../components/iconMaster/Icons";
import GlobalSearch from "../../globalSearch";
import { useCustomNavigation } from "../../../utility/useCustomNavigation";
import { capitalizeFirstLetter } from "../../../utility/utils";
const GroupTour = lazy(() => import("./groupTour"));
const IndiaTour = lazy(() => import("./indiaTour"));
const WorldTour = lazy(() => import("./worldTour"));
const SpecialityTours = lazy(() => import("./specialityTours"));
const CustomizedHolidays = lazy(() => import("./customizedHolidays"));
const MoreMenu = lazy(() => import("./moreMenu"));
const PackagesHeader = lazy(() => import("./Packages"));
const Login = lazy(() => import("../../partnersZone/agent/login"));
const UserLogin = lazy(() => import("../../endUser/login"));

export default function Header({
    showLogin,
    setShowLogin,
    globalSearchPopup,
    setGlobalSearchPopup
}: any) {
    const location = useLocation();
    const dispatch = useAddDispatch();
    const { handleNavigate, handleNavigatePackages } = useCustomNavigation();
    const { user, isLoggedIn } = useAppSelector((state) => state.userSlice);
    const [hasLoggedOut, setHasLoggedOut] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [submenuOpen, setSubmenuOpen] = useState<string | null>(null);
    const [suppressHoverMenu, setSuppressHoverMenu] = useState(false);
    const suppressHoverUntilRef = useRef(0);

    const handleLogout = () => {
        dispatch(logout());
        setHasLoggedOut(true);
    }
    useEffect(() => {
        let timeoutId: any;
        if (location.pathname !== "/") return;

        if (!isLoggedIn && !hasLoggedOut) {
            timeoutId = setTimeout(() => {
                setShowLogin(false);
            }, 10000); // 10 seconds
        }

        return () => clearTimeout(timeoutId); // Cleanup to prevent memory leaks or showing when user logs in
    }, [isLoggedIn, hasLoggedOut]);

    // Detect screen size
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 992);
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const openMenu = () => setIsMenuOpen(true);
    const closeMenu = (event?: React.MouseEvent) => {
        if (event) event.stopPropagation();
        setIsMenuOpen(false);
        setSubmenuOpen(null);
        // Desktop mega menus are CSS :hover based — force-hide after click
        suppressHoverUntilRef.current = Date.now() + 400;
        setSuppressHoverMenu(true);
    };

    useEffect(() => {
        setSubmenuOpen(null);
        setIsMenuOpen(false);
        // Do NOT clear suppressHoverMenu here — that reopens the mega menu
        // while the cursor is still over it after navigation.
    }, [location.pathname]);

    // Keep mega menu closed until the pointer leaves the header nav
    useEffect(() => {
        if (!suppressHoverMenu) return;

        const unlockHoverMenu = (event: MouseEvent) => {
            if (Date.now() < suppressHoverUntilRef.current) return;
            const nav = document.querySelector(".header ul.main-menu");
            const target = event.target as Node | null;
            if (nav && target && !nav.contains(target)) {
                setSuppressHoverMenu(false);
            }
        };

        document.addEventListener("mousemove", unlockHoverMenu, true);
        return () => document.removeEventListener("mousemove", unlockHoverMenu, true);
    }, [suppressHoverMenu]);

    useEffect(() => {
        if (!isMenuOpen) return;
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = previousOverflow;
        };
    }, [isMenuOpen]);

    useEffect(() => {
        if (!isMobile) {
            setIsMenuOpen(false);
            setSubmenuOpen(null);
        }
    }, [isMobile]);

    const openSubmenu = (menu: string) => {
        setSuppressHoverMenu(false);
        setSubmenuOpen(menu);
    };

    const backToMainMenu = () => {
        setSubmenuOpen(null);
    };
    const handleNavigateToPackages = () => {
        const obj = { type: "packagetype", id: "customized", name: "customized" }
        handleNavigatePackages(obj);
    }

    return (
        <>
            <header id="header" className="bg-white header sticky-top">
                <div className="container">
                    <nav className="navbar d-flex align-items-center justify-content-between flex-nowrap gap-2">
                        <Link className="navbar-brand flex-shrink-0" to="/">
                            <img loading="lazy" height={58} src="../../../assets/images/logo.png" alt="" />
                            {process.env.REACT_APP_ENV === "qa" && <strong className="text-qa">QA</strong>}
                        </Link>
                        <div className="headerMenu flex-grow-1">
                            {/* <input type="radio" name="slider" id="menubar" />
                            <input type="radio" name="slider" id="close-btn" /> */}
                            <div className="wrap">
                                <div className="searchbox">
                                    <GlobalSearch />

                                    <button type="button" className="searchButton">
                                        <i className="bx bx-search"></i>
                                    </button>
                                </div>
                            </div>

                            <ul className="top-menu list-unstyled mt-2 mb-3">
                                {/* <li><a role="button" onClick={() => setGlobalSearchPopup(true)}><i className='bx bx-search'></i> <span>Search</span> </a></li> */}
                                <li>
                                    <a role="button" className="desktop-item"><i className='bx bx-support'></i> <span>Support</span> <i className="bx bx-chevron-down"></i></a>


                                    <ul className="support-dropdown">

                                        <li className="support-header">

                                            <div>
                                                <h4>We're here to help!</h4>
                                                <p>Reach out to us for any travel assistance.</p>
                                            </div>

                                            <div className="help-icon">
                                                <Icons
                                                    name="help-icon"
                                                    width="64px"
                                                    height="64px"
                                                />
                                            </div>

                                        </li>

                                        {[
                                            {
                                                title: "Customer Support",
                                                icon: "support_21",
                                                numbers: [
                                                    {
                                                        value: "+91 22 6940 8302",
                                                        type: "phone",
                                                    },
                                                    {
                                                        value: "+91 973 973 7528",
                                                        type: "whatsapp",
                                                    },
                                                ],
                                                action: "tel:+912269408302",
                                            },
                                            {
                                                title: "For India Tour Inquiry",
                                                icon: "sales-support",
                                                numbers: ["+91 973 973 7514"],
                                                action: "tel:+919739737514",
                                            },
                                            {
                                                title: "For International Tour Inquiry",
                                                icon: "international-support",
                                                numbers: ["+91 973 973 7513"],
                                                action: "tel:+919739737513",
                                            },
                                        ].map((item, index) => (
                                            <li key={index} className="support-card">
                                                <div className="support-icon">
                                                    <Icons
                                                        name={item.icon}
                                                        width="24px"
                                                        height="24px"
                                                    />
                                                </div>

                                                <div className="support-content">
                                                    <h6>{item.title}</h6>

                                                    {item.numbers.map((number, i) => {
                                                        if (typeof number === "string") {
                                                            return (
                                                                <a key={i} href={`tel:${number.replace(/\D/g, "")}`}>
                                                                    <i className="bx bxs-phone"></i>
                                                                    {number}
                                                                </a>
                                                            );
                                                        }

                                                        return (
                                                            <a
                                                                key={i}
                                                                href={
                                                                    number.type === "whatsapp"
                                                                        ? `https://wa.me/${number.value.replace(/\D/g, "")}`
                                                                        : `tel:${number.value.replace(/\D/g, "")}`
                                                                }
                                                            >
                                                                <i
                                                                    className={
                                                                        number.type === "whatsapp"
                                                                            ? "bx bxl-whatsapp"
                                                                            : "bx bxs-phone"
                                                                    }
                                                                ></i>
                                                                {number.value}
                                                            </a>
                                                        );
                                                    })}
                                                </div>

                                                {/* <a href={item.action} className="call-btn">
                                                    <i className="bx bx-phone-call"></i>
                                                    Call
                                                </a> */}
                                            </li>
                                        ))}

                                        

                                        <li className="support-card">

                                            <div className="support-icon blue">
                                                <Icons
                                                    name="mail"
                                                    width="24px"
                                                    height="24px"
                                                />
                                            </div>

                                            <div className="support-content">
                                                <h6>Email Us</h6>
                                                <a href="mailto:travels@geniusworld.in">
                                                    travels@geniusworld.in
                                                </a>
                                            </div>

                                        </li>
                                        <li className="support-card">

                                            <div className="support-icon">
                                                <Icons
                                                    name="operating"
                                                    width="24px"
                                                    height="24px"
                                                />
                                            </div>

                                            <div className="support-content">

                                                <h6>Business Hours</h6>

                                                <p className="mb-0">10:00 AM - 7:00 PM (IST)</p>

                                                <span>Monday to Sunday</span>

                                            </div>

                                            {/* <div className="time-chip">
                                                10AM - 7PM
                                            </div> */}

                                        </li>

                                        <li className="support-footer">
                                            <div className="support-footer-icon">
                                                <i className="bx bxs-shield-alt-2"></i>
                                            </div>

                                            <p className="support-footer-text">
                                                Your journey is important to us. <strong>We'll get back to you as soon as possible!</strong>
                                            </p>
                                        </li>

                                    </ul>
                                </li>

                                <li><Link to="/registration"><i className='bx bxs-user-circle'></i> <span>Register</span></Link></li>

                                {isLoggedIn && <li>
                                    <a role="button" className="nav-link user-name" title={`${capitalizeFirstLetter(user?.firstName || "")} ${capitalizeFirstLetter(user?.lastName || "")}`}>
                                        <i className="bx bx-user"></i>
                                        <span className="welcome-text">Welcome,</span>
                                        <span className="user-text">
                                            {`${capitalizeFirstLetter(user?.firstName || "")} ${capitalizeFirstLetter(user?.lastName || "")}`}
                                        </span>
                                    </a>
                                    <ul className="item inter-regular">
                                        <li>
                                            <div className="d-flex">
                                                <div className="list-item">
                                                    <a
                                                        role="button"
                                                        className="nav-link" title="Logout"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handleLogout();
                                                        }}
                                                    >Logout</a>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                                }
                                {!isLoggedIn &&
                                    <li className="nav-item">
                                        <a role="button" className="nav-link user-name"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                startTransition(() => {
                                                    setShowLogin(true);
                                                });
                                            }}
                                        >
                                            <i className='bx bx-user'></i> <span>Login</span>
                                        </a>
                                    </li>
                                }
                            </ul>


                            <button className="btn hamburger" onClick={openMenu}>
                                <i className="fa fa-bars"></i>
                            </button>
                            {isMenuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}
                            <div className={`mobile-menu ${isMenuOpen ? "active" : ""}`}>
                                <ul
                                    className={`main-menu inter-regular ${submenuOpen ? "submenu-active" : ""} ${suppressHoverMenu ? "suppress-hover-menu" : ""}`}
                                >
                                    <button className="btn close-btn" onClick={closeMenu}>
                                        <i className="bx bx-x"></i>
                                    </button>
                                    <IndiaTour
                                        isMobile={isMobile}
                                        openSubmenu={openSubmenu}
                                        backToMainMenu={backToMainMenu}
                                        submenuOpen={submenuOpen === "indiaTours"}
                                        closeMenu={closeMenu}
                                    />
                                    <WorldTour
                                        isMobile={isMobile}
                                        openSubmenu={openSubmenu}
                                        backToMainMenu={backToMainMenu}
                                        submenuOpen={submenuOpen === "WorldTours"}
                                        closeMenu={closeMenu}
                                    />
                                    {/* <GroupTour
                                        isMobile={isMobile}
                                        openSubmenu={openSubmenu}
                                        backToMainMenu={backToMainMenu}
                                        submenuOpen={submenuOpen === "groupTours"}
                                        closeMenu={closeMenu}
                                    /> */}
                                    <SpecialityTours
                                        isMobile={isMobile}
                                        openSubmenu={openSubmenu}
                                        backToMainMenu={backToMainMenu}
                                        submenuOpen={submenuOpen === "specialityTours"}
                                        closeMenu={closeMenu}
                                    />

                                    <CustomizedHolidays
                                        isMobile={isMobile}
                                        openSubmenu={openSubmenu}
                                        backToMainMenu={backToMainMenu}
                                        submenuOpen={submenuOpen === "customizedHolidays"}
                                        closeMenu={closeMenu}
                                    />

                                    {/* <li><a onClick={() => { closeMenu(); handleNavigateToPackages(); }}>Customized Holidays</a></li> */}
                                    {/* <li><Link to="/groupweddings" onClick={closeMenu}>Groups & Weddings</Link></li> */}
                                    <li><Link to="/bookManage" onClick={closeMenu}>Book & Manage</Link></li>
                                    <li><Link to="/blog-artical" onClick={closeMenu}>Blogs</Link></li>

                                    <MoreMenu
                                        isMobile={isMobile}
                                        openSubmenu={openSubmenu}
                                        backToMainMenu={backToMainMenu}
                                        submenuOpen={submenuOpen === "more"}
                                        closeMenu={closeMenu}
                                    />
                                    {/* <PackagesHeader
                                        isMobile={isMobile}
                                        openSubmenu={openSubmenu}
                                        backToMainMenu={backToMainMenu}
                                        submenuOpen={submenuOpen === "packages"}
                                        closeMenu={closeMenu}
                                    /> */}

                                    {/* <li className="menu-with-submenu">
                                        <Link
                                            to={"/destination"}>
                                            Testing menu <span onClick={(e) => {
                                                if (isMobile) {
                                                    e.preventDefault();
                                                    openSubmenu("packages"); // open this submenu
                                                }
                                            }} className="submenu-arrow"><i className="fa fa-angle-down"></i></span>
                                        </Link>

                                        <ul className={`sub-menu mega-menu ${submenuOpen ? "open" : ""}`}>
                                            {isMobile && (
                                                <div className="submenu-header">
                                                    <span className="back-btn" onClick={backToMainMenu}>
                                                        <i className="bx bx-left-arrow-alt"></i> Back
                                                    </span>
                                                    <h4 className="submenu-title">Testing menu</h4>
                                                </div>
                                            )}
                                            <div className="grid l-columns--2-3">
                                                <div className="list-item">
                                                    <h4 className="list-title inter-regular fw-medium">Upcoming Tours</h4>
                                                    <ul className="list-unstyled grid l-columns--1-1">
                                                        <li><a href="#" onClick={closeMenu}>Ayutthaya</a></li>
                                                        <li><a href="#" onClick={closeMenu}>Bangkok</a></li>
                                                        <li><a href="#">Chiang Mai</a></li>
                                                        <li><a href="#">Kanchanaburi</a></li>
                                                        <li><a href="#">Koh Kood</a></li>
                                                        <li><a href="#">Koh Yao Noi</a></li>
                                                        <li><a href="#">Krabi</a></li>
                                                        <li><a href="#">Pattaya</a></li>
                                                        <li><a href="#">Phuket</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </ul>
                                    </li> */}
                                    {/* Other Main Menu Items */}
                                    {/* <li><Link to="/" onClick={closeMenu}>Trending Tours</Link></li> */}

                                </ul>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
            {/* {showLogin && */}
            {/* <Login */}
            <UserLogin
                showLogin={showLogin}
                setShowLogin={setShowLogin}
            />
            {/* } */}
            {/* Global Search */}
            {/* {globalSearchPopup &&
                <GlobalSearch
                    globalSearchPopup={globalSearchPopup}
                    setGlobalSearchPopup={setGlobalSearchPopup} />
            } */}
        </>
    )
}
